import { PageController } from '@client/components/_core/layout/PageController';
import { OrgContactRoleEdit } from '@client/components/products-v2/OrgContactRoleEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/contact-roles/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Add contact role',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <OrgContactRoleEdit action={['add']} />
        </PageController>
    );
}
